"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowCover = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var RENDER_DATA = CardRenderer_1.CardRenderer.builder(function (b) {
    b.minus().temperature(2).br.cards(1).slash().influence();
});
var SnowCover = (function () {
    function SnowCover() {
        this.name = GlobalEventName_1.GlobalEventName.SNOW_COVER;
        this.description = 'Decrease temperature 2 steps. Draw 1 card per influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
        this.renderData = RENDER_DATA;
    }
    SnowCover.prototype.resolve = function (game, turmoil) {
        game.increaseTemperature(game.getPlayers()[0], -2);
        game.getPlayers().forEach(function (player) {
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    };
    return SnowCover;
}());
exports.SnowCover = SnowCover;
